<div class="wrap-row history text">
    <div class="wrap-row-col-top">
        <div class="col-top-id">
            <span>{{ alarm.channel }}</span>
        </div>
        <div class="hr"></div>
        <div class="col-top-name">{{ alarm.name | uppercase }}</div>
        <div class="hr"></div>
        <div class="col-top-status">
            <app-alarm-status-icon
                [statusText]="alarm.level"
            ></app-alarm-status-icon>
            <span>{{ alarm.status | uppercase }}</span>
        </div>
    </div>
    <div class="wrap-row-col-detail text-small">
        <p>
            {{ alarm.value }}<span *ngIf="alarm.value">&#x2022;</span>
            {{ alarm.category }}<span>&#x2022;</span
            >{{ "alarm.table.occurence" | translate }}
            {{ alarm.occurrenceAt | date: "yyyy/MM/dd" : "UTC" }} at
            {{ alarm.occurrenceAt | date: "HH:mm" : "UTC" }} UTC<span
                >&#x2022;</span
            >
        </p>
        <p>
            {{ "alarm.table.recover" | translate }}
            {{ alarm.recoveryTime | date: "yyyy/MM/dd" : "UTC" }} at
            {{ alarm.recoveryTime | date: "HH:mm" : "UTC" }} UTC
        </p>
    </div>
</div>
